import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import moment from 'moment';
export default {
  props: {
    controlData: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableForm: {},
      dataSource: [],
      columnInfo: [],
      mergeCells: [],
      mergeCellData: [],
      autoIncrement: false,
      rules: {},
      resData: {},
      showTableHeader: true,
      showTabletTail: false,
      validateStatus: false,
      tableType: ''
    };
  },
  computed: {
    dataLastLine() {
      if (this.showTabletTail) {
        return this.dataSource.length - 2;
      } else {
        return this.dataSource.length - 1;
      }
    },
    dataSourceStartLine() {
      if (this.showTableHeader) {
        return this.resData.tableHeadNum;
      } else {
        return 0;
      }
    }
  },
  mounted() {
    this.resData = this.controlData.containerTemplateInfo;
    this.echoData = [];
    if (this.controlData.value) {
      //回显数据
      let headerInfo = this.controlData.value.headerInfo;
      let dataSource = this.controlData.value.dataInfo;
      let radioValue = this.controlData.value.radioValue;
      headerInfo.forEach((headerRow, rowIndex) => {
        headerRow && Array.isArray(headerRow) && headerRow.forEach((cellValue, lineIndex) => {
          let currentKey = rowIndex + ',' + lineIndex;
          let value = radioValue[currentKey] ? radioValue[currentKey] : cellValue.text;
          this.$set(this.tableForm, currentKey, value);
        });
      });
      dataSource.forEach((dataRow, rowIndex) => {
        let rowData = [];
        let dataRowKeyArr = Object.keys(dataRow);
        dataRowKeyArr.forEach((cellKey, lineIndex) => {
          let cellValue = dataRow[cellKey];
          rowData.push(cellValue || '');
          let currentKey = rowIndex + this.dataSourceStartLine + ',' + lineIndex;
          // let valueKey = 'column' + lineIndex;
          let value = radioValue[currentKey] ? radioValue[currentKey] : cellValue;
          this.$set(this.tableForm, currentKey, value);
        });
        this.echoData.push(rowData);
      });
    }
    this.handleTableData();
  },
  methods: {
    generationData2() {
      let radioValue = {};
      Array.isArray(this.headerInfo) && this.headerInfo.forEach((item, index) => {
        item.forEach((cellItem, i) => {
          let currentKey = index + ',' + i;
          if (cellItem.control === 'text') {
            let inputValue = this.tableForm[currentKey] || '';
            cellItem.text = cellItem.prefix + inputValue + cellItem.suffix;
          } else if (cellItem.control === 'date') {
            let inputValue = this.tableForm[currentKey] ? moment(this.tableForm[currentKey]).format(cellItem.controlScope) : '';
            cellItem.text = cellItem.prefix + inputValue + cellItem.suffix;
          } else if (cellItem.control === 'radio') {
            let radio = this.tableForm[currentKey] || '';
            radioValue[currentKey] = radio;
            let text = '';
            cellItem.controlScope.split(';').forEach(radioItem => {
              if (radioItem === radio) {
                text = text + '☑' + radioItem + ' ';
              } else {
                text = text + '☐' + radioItem + ' ';
              }
            });
            cellItem.text = cellItem.prefix + text + cellItem.suffix;
          }
        });
      });
      let dataSource = [];
      this.dataSource.forEach((row, rowIndex) => {
        let obj = {};
        if (this.showTableHeader && rowIndex >= this.resData.tableHeadNum || !this.showTableHeader) {
          Object.keys(row).forEach((key, i) => {
            let cell = row[key].text;
            let cellItem = this.listInfo[i];
            let currentKey = rowIndex + ',' + i;
            let text = cell || '';
            if (rowIndex > this.dataLastLine) {
              text = cell;
            } else if (!cell && (cellItem.control === 'text' || cellItem.control === 'number')) {
              text = this.tableForm[currentKey];
            } else if (!cell && cellItem.control === 'date') {
              text = this.tableForm[currentKey] ? moment(this.tableForm[currentKey]).format(cellItem.controlScope) : '';
            } else if (!cell && cellItem.control === 'radio') {
              let radio = this.tableForm[currentKey];
              radioValue[currentKey] = radio;
              cellItem.controlScope.split(';').forEach(radioItem => {
                if (radioItem === radio) {
                  text = text + '☑' + radioItem + ' ' || '';
                } else {
                  text = text + '☐' + radioItem + ' ' || '';
                }
              });
            }
            obj[key] = text || '';
          });
          dataSource.push(obj);
        }
      });
      this.controlData.value = {
        headerInfo: this.headerInfo,
        dataInfo: dataSource,
        radioValue
      };
    },
    handleTableData() {
      //处理表格数据
      this.autoIncrement = this.resData.autoincrement === 'YES' ? true : false;
      this.tableType = this.resData.tableType;
      this.showTableHeader = this.resData.tableHead === 'YES' ? false : true;
      this.showTabletTail = this.resData.tableTail === 'YES' ? false : true;
      // console.log(typeof this.resData.rawData, '-------this.resData.rawData表格数据处理---------');
      if (this.resData.rawData !== undefined) {
        let rawData = this.resData.rawData ? JSON.parse(this.resData.rawData) : this.resData.rawData;
        this.cellStyleSet = JSON.parse(rawData.cellStyleObj);
        let tableData = JSON.parse(rawData.tableData);
        console.log(tableData, '-------tableData表格数据处理---------');
        this.tableData = tableData;
        let columnNum = rawData.columnNumber;
        this.generationColumn(columnNum);
        this.mergeCells = JSON.parse(rawData.mergeCells);
        //处理合并单元格数据
        this.formatMergeCellData();
        let headerInfo = JSON.parse(this.resData.headerInfo);
        this.headerInfo = headerInfo;
        let listInfo = JSON.parse(this.resData.listInfo);
        this.listInfo = listInfo;
        if (this.resData.tableHead === 'NO') {
          this.handleTableHeader(headerInfo);
        }
        let echoData = tableData;
        if (this.controlData.value && this.tableType === 'increment') {
          let headerNum = this.resData.tableHeadNum;
          let headerData = tableData.splice(0, headerNum);
          let dataSource = tableData[0];
          let newData = [];
          let tailData = this.showTabletTail ? [tableData[tableData.length - 1]] : [];
          let leng = this.showTabletTail ? this.echoData.length - 1 : this.echoData.length;
          for (let i = 0; i < leng; i++) {
            newData.push(JSON.parse(JSON.stringify(dataSource)));
          }
          echoData = [...headerData, ...newData, ...tailData];
        }
        this.handleDataSource(echoData, listInfo);
      }
    },
    generationColumn(columnNum) {
      let column = [];
      for (let i = 1; i <= columnNum; i++) {
        column.push({
          dataIndex: `column${i}`,
          title: `column${i}`
        });
      }
      this.columnInfo = column;
    },
    handleDataSource(tableData, listInfo) {
      if (this.autoIncrement) {
        this.TableMaxIndex = tableData.length - this.resData.tableHeadNum;
      }
      tableData.forEach((item, index) => {
        if (index >= this.resData.tableHeadNum) {
          let obj = {};
          item.forEach((cell, i) => {
            if (this.showTabletTail && index === tableData.length - 1) {
              let key = `column${i + 1}`;
              let currentKey = `${index},${i}`;
              obj[key] = {
                prefix: '',
                display: '',
                suffix: '',
                text: cell,
                tablePosition: currentKey
              };
            } else {
              let key = `column${i + 1}`;
              let listSetting = listInfo[i];
              let currentKey = `${index},${i}`;
              obj[key] = {
                prefix: '',
                display: listSetting.control,
                suffix: '',
                text: cell,
                tablePosition: `${index},${i}`,
                controlScope: listSetting.controlScope
              };
              let controlScope = listSetting.controlScope;
              if (!cell && listSetting.control === 'text') {
                obj[key].textMinLength = Number(controlScope.split(',')[0]);
                obj[key].textMaxLength = Number(controlScope.split(',')[1]);
                let msg = this.$t('长度在0到1个字符').replace('0', obj[key].textMinLength).replace('1', obj[key].textMaxLength);
                obj[key].rule = [{
                  min: Number(obj[key].textMinLength),
                  max: Number(obj[key].textMaxLength),
                  message: msg,
                  trigger: 'blur'
                }];
                this.$set(this.rules, currentKey, obj[key].rule);
              } else if (!cell && listSetting.control === 'radio') {
                obj[key].radioOption = controlScope.split(';');
              } else if (!cell && listSetting.control === 'date') {
                obj[key].formatType = controlScope;
              } else if (!cell && listSetting.control === 'number') {
                let minNumber = Number(controlScope.split(',')[0]);
                let maxNumber = Number(controlScope.split(',')[1]);
                let validatePass2 = (rule, value, callback) => {
                  let reg = /^([0-9])*([.])*([0-9])*$/g;
                  if (value && !reg.test(value)) {
                    callback(new Error(this.$t('请输入数字')));
                  } else if (value) {
                    let msg = this.$t('请输入0到1之间的数字').replace('0', minNumber).replace('1', maxNumber);
                    if (value < minNumber || value > maxNumber) {
                      callback(new Error(msg));
                    } else {
                      callback();
                    }
                  } else {
                    callback();
                  }
                };
                obj[key].rule = [{
                  validator: validatePass2,
                  trigger: 'blur'
                }];
                this.$set(this.rules, currentKey, obj[key].rule);
              }
            }
          });
          this.dataSource.push(obj);
        }
      });
    },
    formatMergeCellData() {
      //处理表格合并单元格数据
      this.mergeCells.forEach(item => {
        let obj = {
          rowIndex: item.from.row,
          lineIndex: item.from.col,
          action: {
            rowspan: item.to.row - item.from.row + 1,
            colspan: item.to.col - item.from.col + 1
          }
        };
        this.mergeCellData.push(obj);
        for (let i = item.from.row; i <= item.to.row; i++) {
          for (let j = item.from.col; j <= item.to.col; j++) {
            if (i !== item.from.row || j !== item.from.col) {
              let obj1 = {
                rowIndex: i,
                lineIndex: j,
                action: {
                  rowspan: 0,
                  colspan: 0
                }
              };
              this.mergeCellData.push(obj1);
            }
          }
        }
      });
    },
    handleTableHeader(headerInfo) {
      //设置表头区数据
      Array.isArray(headerInfo) && headerInfo.forEach((item, index) => {
        let obj = {};
        item.forEach((cell, i) => {
          let key = `column${i + 1}`;
          let currentKey = index + ',' + i;
          let currentCellStyleObj = this.cellStyleSet[currentKey];
          obj[key] = {
            prefix: currentCellStyleObj ? currentCellStyleObj.prefix : '',
            display: currentCellStyleObj ? currentCellStyleObj.control : '',
            suffix: currentCellStyleObj ? currentCellStyleObj.suffix : '',
            text: currentCellStyleObj && currentCellStyleObj.control ? '' : cell.text,
            tablePosition: `${index},${i}`
          };
          if (currentCellStyleObj) {
            let controlScope = cell.controlScope;
            if (cell.control === 'text' && controlScope) {
              // debugger;
              obj[key].textMinLength = controlScope.split(',')[0];
              obj[key].textMaxLength = controlScope.split(',')[1];
              let msg = this.$t('长度在0到1个字符').replace('0', obj[key].textMinLength).replace('1', obj[key].textMaxLength);
              obj[key].rule = [{
                min: Number(obj[key].textMinLength),
                max: Number(obj[key].textMaxLength),
                message: msg,
                trigger: 'blur'
              }];
              this.$set(this.rules, currentKey, obj[key].rule);
            } else if (cell.control === 'radio') {
              let optionValues = currentCellStyleObj.optionValues;
              obj[key].radioOption = optionValues.split(';');
            } else if (cell.control === 'date') {
              obj[key].formatType = controlScope;
            }
          }
        });
        this.dataSource.push(obj);
      });
    },
    objectSpanMethod({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      let finsItem = this.mergeCellData.find(item => {
        return item.rowIndex === rowIndex && item.lineIndex === columnIndex;
      });
      if (finsItem) {
        return finsItem.action;
      }
    },
    tableCellStyle({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      let currentKey = `${rowIndex},${columnIndex}`;
      let currentCellStyleObj = this.cellStyleSet[currentKey];
      if (currentCellStyleObj && currentCellStyleObj.bgColorValue) {
        return {
          backgroundColor: currentCellStyleObj.bgColorValue
        };
      } else {
        return {
          backgroundColor: '#fff'
        };
      }
    },
    add() {
      let obj = {};
      let idx = this.dataSource.length;
      if (this.showTableHeader) {
        idx = idx - this.resData.tableHeadNum;
      }
      if (this.showTabletTail) {
        idx = idx - 1;
      }
      this.listInfo.forEach((item, index) => {
        let key = `column${index + 1}`;
        let currentKey = `${this.dataLastLine + 1},${index}`;
        if (index === 0 && this.autoIncrement) {
          obj[key] = {
            prefix: '',
            display: '',
            suffix: '',
            text: idx + 1,
            tablePosition: currentKey
          };
        } else {
          obj[key] = {
            prefix: '',
            display: item.control,
            suffix: '',
            text: '',
            tablePosition: currentKey
          };
          let controlScope = item.controlScope;
          if (item.control === 'text') {
            obj[key].textMinLength = controlScope.split(',')[0];
            obj[key].textMaxLength = controlScope.split(',')[1];
            let msg = this.$t('长度在0到1个字符').replace('0', obj[key].textMinLength).replace('1', obj[key].textMaxLength);
            obj[key].rule = [{
              min: Number(obj[key].textMinLength),
              max: Number(obj[key].textMaxLength),
              message: msg,
              trigger: 'blur'
            }];
            this.$set(this.rules, currentKey, obj[key].rule);
          } else if (item.control === 'radio') {
            obj[key].radioOption = controlScope.split(';');
          } else if (!item.text && item.control === 'date') {
            obj[key].formatType = controlScope;
          }
        }
      });
      this.dataSource.splice(this.dataLastLine + 1, 0, obj);
    },
    deleteFun(index) {
      let formKey = [];
      this.dataSource.forEach((item, i) => {
        if (i === index) {
          Object.keys(item).forEach(key => {
            formKey.push(item[key].tablePosition);
            if (this.rules[item[key].tablePosition]) {
              this.$delete(this.rules, item[key].tablePosition);
            }
          });
        }
      });
      if (this.autoIncrement) {
        this.dataSource.forEach((item, i) => {
          if (i === index) {
            Object.keys(item).forEach(key => {
              formKey.push(item[key].tablePosition);
              this.$delete(this.tableForm, item[key].tablePosition);
              if (this.rules[item[key].tablePosition]) {
                this.$delete(this.rules, item[key].tablePosition);
              }
            });
          }
        });
      }
      this.dataSource.splice(index, 1);
      this.TableMaxIndex--;
    },
    validateForm() {
      this.$refs.form.validate(valid => {
        this.validateStatus = valid;
        if (valid) {
          this.$emit('validateForm', this.tableForm);
        } else {
          this.$message.error(this.$t(this.$t('请检查表格数据')));
          return false;
        }
      });
    }
  }
};